import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './layout/app/App';
import reportWebVitals from './reportWebVitals';
import { Header } from './layout/header/Header';
import { Footer } from './layout/footer/Footer';
import { IntegrationProvider } from './contexts/IntegrationContext';
import './i18n';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Header />
    <BrowserRouter>
      <IntegrationProvider>
        <App />
      </IntegrationProvider>
    </BrowserRouter>
    <Footer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
